<template>
    <div :key="rowId" class="table-cell-wrapper_content / flex">
        {{ formattedAmount }}&nbsp;
        <VJoyTooltip v-if="hasPaymentTooltip" variant="secondary" class="joy-tooltip table_total_tooltip" placement="bottom">
            <div ref="cellContent">
                <VJoyIcon name="warning-triangle" color="error" />
            </div>
            <template #tooltip-content>
                <p>
                    <span class="joy-font-primary-250">{{ $t('projectclient.projectlist.table.total.tooltip.title') }}</span>
                    <br />
                    {{ tooltipContent }}
                </p>
            </template>
        </VJoyTooltip>
    </div>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {differenceInDays, isAfter, subDays} from 'date-fns';
    import {useTranslation, useFormat} from '#imports';
    import {VJoyIcon, VJoyTooltip} from '@maltjoy/core-vue';
    import type {FormattedClientProjectResource} from '@/features/projects-list';

    const props = defineProps<{
        rowId: string;
        paymentLimitDate?: Date;
        project?: FormattedClientProjectResource;
    }>();

    const {formatAmount} = useFormat();

    const {t} = useTranslation();

    const formattedAmount = computed(() =>
        !!props.project?.total && !isNaN(props.project?.total) ? formatAmount(props.project.currency, props.project.total, {decimals: 2}) : '-',
    );

    const hasPaymentTooltip = computed(() => {
        if (props.paymentLimitDate) {
            const threeDaysBeforePaymentLimit = subDays(props.paymentLimitDate, 3);
            return isAfter(new Date(), threeDaysBeforePaymentLimit);
        }
        return false;
    });

    const tooltipContent = computed(() => {
        if (hasPaymentTooltip.value) {
            const daysToPaymentLimit = differenceInDays(new Date(), props.paymentLimitDate!);
            if (daysToPaymentLimit <= 0) {
                return t('projectclient.projectlist.table.total.close.to.payment.limit', {0: daysToPaymentLimit});
            }
            return t('projectclient.projectlist.table.total.payment.overdue', {0: daysToPaymentLimit});
        }
        return '';
    });
</script>

<style lang="scss" scoped>
    .table-cell-wrapper_content {
        flex-flow: row nowrap;
    }

    .table_total_tooltip {
        margin-left: var(--joy-core-spacing-2);
        margin-top: 3%;
    }
</style>
